"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAnalyticOnEvent = void 0;
var react_1 = __importDefault(require("react"));
var wrapDisplayName_1 = require("../wrapDisplayName");
var use_event_analytic_1 = require("../hooks/use-event-analytic");
function withAnalyticOnEvent(_a) {
    var eventName = _a.eventName, analyticName = _a.analyticName, extendAnalyticsFromConfig = _a.extendAnalytics;
    return function (BaseComponent) {
        var EnhancedComponent = function (_a) {
            var _b;
            var _c = eventName, rawEvent = _a[_c], extendAnalytics = _a.extendAnalytics, shouldDispatchAnalytics = _a.shouldDispatchAnalytics, props = __rest(_a, [typeof _c === "symbol" ? _c : _c + "", "extendAnalytics", "shouldDispatchAnalytics"]);
            var onEvent = use_event_analytic_1.useEventAnalytic(function (dispatcher) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var shouldDispatch = typeof shouldDispatchAnalytics === 'function'
                    ? shouldDispatchAnalytics.apply(void 0, args) : shouldDispatchAnalytics == null || shouldDispatchAnalytics;
                if (shouldDispatch) {
                    if (extendAnalyticsFromConfig) {
                        dispatcher = dispatcher.extend(extendAnalyticsFromConfig.apply(void 0, __spreadArray([props], args)));
                    }
                    if (extendAnalytics) {
                        dispatcher = dispatcher.extend(extendAnalytics.apply(void 0, args));
                    }
                    dispatcher.dispatch(analyticName);
                }
            }, rawEvent);
            return react_1.default.createElement(BaseComponent, __assign({}, (_b = {}, _b[eventName] = onEvent, _b), props));
        };
        EnhancedComponent.displayName = wrapDisplayName_1.wrapDisplayName(BaseComponent, 'withAnalyticOnEvent');
        return EnhancedComponent;
    };
}
exports.withAnalyticOnEvent = withAnalyticOnEvent;
